module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_01@3x-21b3e3ccc613d68fc7ff0b87e49cbf29.webp";